import { TPLCover } from './../Models/TPLCover';
import {Injectable, Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'tplCoversPipe',
  pure:false
})
@Injectable()
export class tplCoversPipe implements PipeTransform {
  transform(tplCovers: Array<TPLCover>, sel:boolean): any {
    return tplCovers.filter(t => t.isSelected==sel);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pipes/tplCoversPipe.ts